// extracted by mini-css-extract-plugin
export default {"voxTracingSearch":"VoxTracingSearch_voxTracingSearch__GDJnI"};